import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../auth/authConfig";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

export const useAuth = () => {
    const { instance, accounts, inProgress } = useMsal();

    const login = async () => {
        try {
            await instance.loginRedirect(loginRequest);
        } catch (error) {
            console.error("Login failed:", error);
            throw error;
        }
    };

    const logout = () => {
        instance.logoutRedirect();
    };

    const getAccessToken = async () => {
        try {
            const response = await instance.acquireTokenSilent({
                ...loginRequest,
                account: accounts[0]
            });
            return response.accessToken;
        } catch (error) {
            if (error instanceof InteractionRequiredAuthError) {
                return instance.acquireTokenRedirect(loginRequest)
                    .then(response => response.accessToken);
            }
            throw error;
        }
    };

    return {
        isAuthenticated: accounts.length > 0,
        user: accounts[0] || null,
        login,
        logout,
        getAccessToken,
        isLoading: inProgress !== "none"
    };
}; 